import { ShieldCheck, FlaskConical, Lock, Clock, Building2 } from "lucide-react";

const ICONS = { ShieldCheck, FlaskConical, Lock, Clock, Building2 };
const POINTS = [
  { icon: "ShieldCheck", label: "Independent & unaffiliated" },
  { icon: "FlaskConical", label: "Lab-grade methods" },
  { icon: "Lock", label: "Secure checkout" },
  { icon: "Clock", label: "7-day turnaround" },
];

const METHODS = ["HPLC", "LC-MS/MS", "GC-MS", "ICP-MS", "UV-Vis", "FTIR"];

export function TrustBar() {
  return (
    <div className="border-y border-border bg-white" data-testid="trust-bar">
      <div className="mx-auto max-w-7xl px-6 py-8 md:px-10">
        {/* Analytical methods */}
        <div className="flex flex-col items-center gap-4 lg:flex-row lg:justify-between">
          <span className="font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-crimson">
            Analytical methods we run
          </span>
          <div className="flex flex-wrap items-center justify-center gap-2" data-testid="methods-chips">
            {METHODS.map((m) => (
              <span key={m} className="rounded-md border border-border bg-secondary px-3 py-1.5 font-mono text-xs font-semibold tracking-tight text-navy">
                {m}
              </span>
            ))}
          </div>
        </div>

        <div className="my-6 h-px bg-border" />

        {/* Credibility points */}
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {POINTS.map((p) => {
            const Icon = ICONS[p.icon];
            return (
              <div key={p.label} className="flex items-center gap-2.5">
                <span className="grid h-9 w-9 place-items-center rounded-md bg-secondary">
                  <Icon className="h-5 w-5 text-crimson" strokeWidth={2} />
                </span>
                <span className="text-sm font-semibold tracking-tight text-navy">{p.label}</span>
              </div>
            );
          })}
        </div>

        <p className="mx-auto mt-6 max-w-3xl text-center font-mono text-[11px] leading-relaxed text-navy/45">
          A professional analytical lab — brand-unaffiliated · documented methods &amp; chain-of-custody · plain-English reports.
        </p>
      </div>
    </div>
  );
}

export function Disclaimer() {
  return (
    <div className="bg-secondary" data-testid="page-disclaimer">
      <div className="mx-auto max-w-7xl px-6 py-3 md:px-10">
        <p className="text-center text-xs text-navy/50">
          <span className="font-semibold text-navy/70">Disclaimer:</span> We are a testing service only.
        </p>
      </div>
    </div>
  );
}
